<template>

  <section class="bg">

    <Header page="settings" title="📣 Feedback"/>

    <div class="container">
      <center v-if="show_spinner" class="spinner">
        <a-spin><a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin /></a-spin>
      </center>
      <div data-canny />
    </div>


  </section>
</template>


<script>

import Header from '@/components/Header.vue';

export default {

  name: 'Feedback',

  components: {
    Header
  },

  data: function () {
    return {
      show_spinner: true
    }
  },

  computed: {},

  mounted() {
    Canny('render', {
      boardToken: '6514edd7-af59-4375-653c-4b62d6c9f538',
      basePath: '/feedback',
      ssoToken: null, // See step 3
    });
    setTimeout(() => {
      this.show_spinner = false
    }, 1500);
  },

  created() {
    analytics.page('Feedback');
  }

};
</script>

<style lang="scss" scoped>

section.bg{
  padding-bottom: 50px;
  background-image: linear-gradient(135deg, #eff0f3 1%,#fefeff 100%);
  min-height: 100%;
}

p{
  color: #0D303F;
}

.spinner{
  margin-top: 50px;
}

.container{
  width: 900px;
  padding: 25px;
  height: auto;
  margin: 0 auto;
  margin-top: 80px;
  background-color: white;
  border: 1px solid rgb(220,220,220);
  border-radius: 6px;
  font-family: 'Montserrat', sans-serif;
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.container{
  width: 90%;
  margin-top: 60px;
}

}

@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .container{
    width: 90%;
    margin-top: 60px;
  }
  .settings-nav{
    div{
      width: 28%;
    }
  }
}



</style>
